import { InputState } from '@kubit/web-ui-components/input/types';
import { withoutDropdownCommonStyles, withoutDropdownDisabledCommonStyles } from '../commonStyles';
import { InputPhoneVariant } from '../variants';
export const getRegularWithoutPrefixDropdownStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputPhoneVariant.REGULAR_WITHOUT_PREFIX_DROPDOWN]: {
            [InputState.EMPTY]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.FILLED]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ACTIVE]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.DISABLED_EMPTY]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
                ...withoutDropdownDisabledCommonStyles(FOUNDATIONS, FONT),
                affix: {
                    ...withoutDropdownDisabledCommonStyles(FOUNDATIONS, FONT).affix,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            },
            [InputState.DISABLED_FILLED]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
                ...withoutDropdownDisabledCommonStyles(FOUNDATIONS, FONT),
                affix: {
                    ...withoutDropdownDisabledCommonStyles(FOUNDATIONS, FONT).affix,
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
            },
            [InputState.DISABLED_FILLED_WITH_INFO]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
                ...withoutDropdownDisabledCommonStyles(FOUNDATIONS, FONT),
                affix: {
                    ...withoutDropdownDisabledCommonStyles(FOUNDATIONS, FONT).affix,
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
            },
            [InputState.ERROR_EMPTY]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_FILLED]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_ACTIVE]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_FILLED_WITH_INFO]: {
                ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=regularWithoutPrefixDropdown.js.map